// CacheKey 222ca1cad4bf589184b8508375e9695c
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ASCENT": {
    simple_form: {
      labels: {
        encounter: {
          encounter_id: "Visit ID",
          encounter_class: "Visit Class",
          surgical_encounter_status: "Surgical Visit Status"
        },
        patient: {
          encounter_id: "Visit"
        }
      }
    }
  }
}

